import React, { FC } from "react";
import { IconType } from "./types";

export const LinkIcon: FC<IconType> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
  >
    <path
      d="M7.9 16.5C7.9 14.79 9.29 13.4 11 13.4H15V11.5H11C8.24 11.5 6 13.74 6 16.5C6 19.26 8.24 21.5 11 21.5H15V19.6H11C9.29 19.6 7.9 18.21 7.9 16.5ZM12 17.5H20V15.5H12V17.5ZM21 11.5H17V13.4H21C22.71 13.4 24.1 14.79 24.1 16.5C24.1 18.21 22.71 19.6 21 19.6H17V21.5H21C23.76 21.5 26 19.26 26 16.5C26 13.74 23.76 11.5 21 11.5Z"
      fill="#BBBBBB"
    />
  </svg>
);
